import React from 'react';
import './Project.css';

const ProjectBacklog: React.FC = () => {
  return (
    <div className="backlog-container">
      <h2>Project Backlog</h2>
      <div className="backlog-content">
        <div className="backlog-section">
          <h3>High Priority</h3>
          <div className="backlog-items">
            <div className="backlog-item high">
              <div className="backlog-item-header">
                <h4>User Authentication</h4>
                <span className="status">In Progress</span>
              </div>
              <p>Implement secure user authentication system with OAuth support</p>
              <div className="backlog-item-footer">
                <span className="effort">Effort: Medium</span>
                <span className="assignee">John D.</span>
              </div>
            </div>
            <div className="backlog-item high">
              <div className="backlog-item-header">
                <h4>Database Schema</h4>
                <span className="status">Pending</span>
              </div>
              <p>Design and implement core database schema</p>
              <div className="backlog-item-footer">
                <span className="effort">Effort: High</span>
                <span className="assignee">Sarah M.</span>
              </div>
            </div>
          </div>
        </div>
        <div className="backlog-section">
          <h3>Medium Priority</h3>
          <div className="backlog-items">
            <div className="backlog-item medium">
              <div className="backlog-item-header">
                <h4>API Documentation</h4>
                <span className="status">Pending</span>
              </div>
              <p>Create comprehensive API documentation</p>
              <div className="backlog-item-footer">
                <span className="effort">Effort: Medium</span>
                <span className="assignee">Mike R.</span>
              </div>
            </div>
          </div>
        </div>
        <div className="backlog-section">
          <h3>Low Priority</h3>
          <div className="backlog-items">
            <div className="backlog-item low">
              <div className="backlog-item-header">
                <h4>Performance Monitoring</h4>
                <span className="status">Pending</span>
              </div>
              <p>Set up performance monitoring and alerting</p>
              <div className="backlog-item-footer">
                <span className="effort">Effort: Low</span>
                <span className="assignee">Unassigned</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectBacklog;
